import api from './api';
import { Package } from './packageService';

/**
 * Get packages for the authenticated user
 */
export const getUserPackages = async () => {
  try {
    const response = await api.get<Package[]>('/users/me/packages');
    return response.data;
  } catch (error) {
    console.error('Error fetching user packages:', error);
    throw error;
  }
};

/**
 * Create a new package
 */
export const createPackage = async (packageData: { 
  name: string; 
  description: string; 
  github_url: string; 
  version: string;
  root_dir?: string;
}) => {
  try {
    const response = await api.post<Package>('/packages/create', packageData);
    return response.data;
  } catch (error) {
    console.error('Error creating package:', error);
    throw error;
  }
};

/**
 * Update a package
 */
export const updatePackage = async (
  packageId: string,
  packageData: Partial<{ 
    name: string; 
    description: string; 
    github_url: string;
    root_dir: string;
  }>
) => {
  try {
    const response = await api.put<Package>(`/packages/${packageId}`, packageData);
    return response.data;
  } catch (error) {
    console.error(`Error updating package ${packageId}:`, error);
    throw error;
  }
};

/**
 * Delete a package
 */
export const deletePackage = async (packageId: string) => {
  try {
    await api.delete(`/packages/${packageId}`);
    return true;
  } catch (error) {
    console.error(`Error deleting package ${packageId}:`, error);
    throw error;
  }
};

/**
 * Publish a package (make it publicly available)
 */
export const publishPackage = async (packageId: string) => {
  try {
    const response = await api.post<Package>(`/packages/${packageId}/publish`, {});
    return response.data;
  } catch (error) {
    console.error(`Error publishing package ${packageId}:`, error);
    throw error;
  }
};

/**
 * Unpublish a package (make it private)
 */
export const unpublishPackage = async (packageId: string) => {
  try {
    const response = await api.post<Package>(`/packages/${packageId}/unpublish`, {});
    return response.data;
  } catch (error) {
    console.error(`Error unpublishing package ${packageId}:`, error);
    throw error;
  }
};

/**
 * Release a new version of a package
 */
export const releaseVersion = async (packageId: string, versionData: { 
  version: string;
  changes: string;
}) => {
  try {
    const response = await api.post<Package>(`/packages/${packageId}/versions`, versionData);
    return response.data;
  } catch (error) {
    console.error(`Error releasing new version for package ${packageId}:`, error);
    throw error;
  }
};
